<template>
    <div class="header header-fixed header-logo-app">
        <a href="#" class="header-title">{{ title }}</a>
        <router-link :to="{ name: backBtn }" class="header-icon header-icon-1"><i class="fas fa-arrow-left"></i></router-link>
    </div>
</template>

<script>

export default {
    name: 'Navbar',
    props: ['title','backBtn'],
    data(){
        return{

        }
    },
}
</script>

<style>
.header {
    background-color: #FFF;
    border-bottom: solid 1px rgba(0,0,0,0.03);
    -webkit-box-shadow: 0 4px 18px 0 rgba(0,0,0,0.08);
    box-shadow: 0 4px 18px 0 rgba(0,0,0,0.08);
    line-height: 23px;
    font-weight: 400;
    color: -internal-root-color;
}
.header, .header-nav {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    height: 55px;
    z-index: 99;
}
.header, .menu-active, .menu {
    transition: transform 300ms ease;
    will-change: transform, opacity;
}

.header-logo-app .header-icon-1 {
    left: 3px;
}

.header .header-icon, .header-nav .header-icon {
    position: absolute;
    height: 55px;
    width: 45px;
    text-align: center;
    line-height: 54px;
    font-size: 12px;
    color: #1f1f1f;
}
.header-logo-app .header-title {
    left: 0px!important;
    margin-left: 55px!important;
}
.header .header-title, .header-nav .header-title {
    position: absolute;
    height: 56px;
    line-height: 56px;
    font-size: 13px;
    color: #000;
    font-weight: 600;
    z-index: 1;
    font-family: 'Poppins', sans-serif;
}
a {
    text-decoration: none
}

div, a, p, img, blockquote, form, fieldset, textarea, input, label, iframe, code, pre {
    display: block;
    position: relative;
}
/* *, *::before, *::after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
* {
    font-family: 'Roboto', sans-serif;
}
*, *:after, *:before {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
}
* {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
    outline: none;
    font-size-adjust: none;
    -webkit-text-size-adjust: none;
    -moz-text-size-adjust: none;
    -ms-text-size-adjust: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-font-smoothing: subpixel-antialiased!important;
    -webkit-transform: translate3d(1,1,1);
    transform: translate3d(1,1,1);
    text-rendering: auto;
    -webkit-font-smoothing: subpixel-antialiased;
    -moz-osx-font-smoothing: grayscale;
} */
</style>